import "./styles.less";
import React from "react";

import { useGuests } from "./Guests.hook";
import { IC_Collapse } from "shared-components/Components/Collapse/web";
import { usePendingFilters } from "shared-components/Contexts/PendingFilters/PendingFiltersContext";

export const Guests = ({ collapsable = false, filters, show, allowOnBlur, changeFilters }) => {
	if (!show) return null;

    const { setPendingFilter } = usePendingFilters();
	const {
		data: { value, setValue },
	} = useGuests({filters});

	const onChangeGuest = value => {
		const patt = /^\+?(0|[1-9]\d*)$/;

		if (patt.test(value)) {
			setValue(value);
		} else {
			setValue(null);
		}
	};

	const handleBlur = () => {
		const resGuests = value
			? { value: value, text: `${value} ${"huéspedes"}` }
			: null;

		if (allowOnBlur) {
			changeFilters({ guests: resGuests });
		} else {
			setPendingFilter('guests', { guests: resGuests });
		}
	}

	const handleChangeGuests = (e) => {
		if (e.target.matches('.plus') || e.target.parentElement.matches('.plus')) {
			if (typeof value === "undefined") onChangeGuest(1)
			else onChangeGuest(value + 1)
		}
		if (e.target.matches('.minus') || e.target.parentElement.matches('.minus')) {
			if (value === 1) onChangeGuest(undefined)
			else onChangeGuest(value - 1)
		}
	}

	if (!show) return null;

	const filter = (
		<div className="container-filter-guests">
			<div
				className="container-input-guests"
				onBlur={handleBlur}
			>
				<button
					className="minus"
					disabled={value === 0}
					onClick={handleChangeGuests}
				>-</button>

				<button
					className="plus"
					onClick={handleChangeGuests}
				>+</button>

				<input
					type="text"
					className="secondary"
					value={value ? `${value}+` : "0+"}
					placeholder={"Huéspedes"}
					onChange={onChangeGuest}
					onMouseDown={(e) => e.preventDefault()}
				/>
			</div>
		</div>
	);

	const label = "Huéspedes";

	return (
		<div className={"filter guests-filter"}>
			{collapsable 
				? <IC_Collapse label={label} isActive={value >= 1} startOpen={value >= 1}>
					{filter}
				</IC_Collapse>
				: <>
					<h3 className="filter-title">{label}</h3>
					{filter}
					<hr style={{width:"100%", border:'none', borderTop:'1px solid rgba(0,0,0,.06)', margin:'24px 0'}} />
				</>
			}
		</div>
	);
};
